
import React from "react";
import { Link } from "react-router-dom";

const HeroSection: React.FC = () => {
  return (
    <div className="relative min-h-screen flex items-center justify-center bg-black">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1618160702438-9b02ab6515c9?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80')] bg-cover bg-center">
        <div className="absolute inset-0 bg-gradient-to-r from-black to-black/70"></div>
      </div>

      {/* Hero Content */}
      <div className="container-custom relative z-10 text-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-display font-bold mb-6 animate-fade-in">
          <span className="text-lounge-light">Winnipeg's Premier</span>
          <br />
          <span className="text-lounge-gold">Hookah Lounge</span>
        </h1>

        <p className="text-xl md:text-2xl text-lounge-light/90 max-w-3xl mx-auto mb-8 animate-fade-in" style={{ animationDelay: "0.2s" }}>
          Experience the finest hookah, food, and drinks in a luxurious ambiance.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in" style={{ animationDelay: "0.4s" }}>
          <Link to="/menu" className="btn-primary w-full sm:w-auto">
            View Menu
          </Link>
          <Link to="/events" className="btn-outline w-full sm:w-auto">
            Upcoming Events
          </Link>
          <Link to="/contact" className="btn-outline w-full sm:w-auto">
            Book Now
          </Link>
        </div>
      </div>

      {/* Scroll Down Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-[30px] h-[50px] rounded-full border-2 border-lounge-gold flex justify-center">
          <div className="w-1 h-3 bg-lounge-gold rounded-full mt-2 animate-[bounce_1.5s_infinite]"></div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
